import { createContext, useContext } from 'react'

const Context = createContext<TTracking>({})

const TrackingProvider = ({ data, children }: TTrackingProviderProps) => {
  return <Context.Provider value={data}>{children}</Context.Provider>
}

const useTracking = () => useContext(Context)

export { TrackingProvider, useTracking }
